import { Modal } from '@mui/material';
import { clsx } from 'clsx';
import React from 'react';

import { Htag } from '@/components/Htag';
import { IconClose } from '@/components/Icons/IconClose';
import { useCssQuery } from '@/providers/MediaQuery';

import { NotificationCreatingForm } from './Form';
import styles from './NotificationCreating.module.css';

interface IOperatorsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const NotificationCreatingModal: React.FC<IOperatorsModalProps> = (
  props,
) => {
  const { isOpen, onClose } = props;
  const { isTabled, isMobile } = useCssQuery();

  return (
    <div>
      <Modal open={isOpen}>
        <div
          className={clsx(styles.root, {
            [styles.isTabled]: isTabled,
            [styles.isMobile]: isMobile,
          })}
        >
          <div className={styles.closeIconWrapper} onClick={onClose}>
            <IconClose className={styles.closeIcon} />
          </div>

          <div className={styles.content}>
            <Htag tag="h2">Создать уведомление клиенту</Htag>
            <NotificationCreatingForm />
          </div>
        </div>
      </Modal>
    </div>
  );
};
